import {ChangeDetectionStrategy, Component} from '@angular/core';
import {LoaderService} from "./loader.service";
import {ProgressBarMode} from '@angular/material/progress-bar';
import { MaterialModule } from 'src/app/app.materials';
import { AsyncPipe, CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading-bar',
  templateUrl: './loading-bar.component.html',
  styleUrls: ['./loading-bar.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MaterialModule, AsyncPipe, CommonModule]
})
export class LoadingBarComponent {
  mode: ProgressBarMode = 'determinate';
  value = 50;
  bufferValue = 75;

  constructor(public loaderService: LoaderService) { }
}
